import { Modal, TextField } from 'melp-design/components';
import { FC } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form-latest';
import { useTranslation } from 'react-i18next';
import { useCreateCustomCategory } from 'store/custom-categories';
import { ModalProps } from 'store/modal';

interface Values {
  name: string;
}

interface Props extends ModalProps {}

export const CreateCustomCategoryModal: FC<Props> = ({ closeModal }) => {
  const { t } = useTranslation();

  const { control, handleSubmit } = useForm<Values>({
    defaultValues: { name: '' },
  });

  const { mutate: createCustomCategory, isLoading } = useCreateCustomCategory();

  const onSubmit: SubmitHandler<Values> = (values) => {
    createCustomCategory(
      {
        name: values.name,
      },
      {
        onSuccess: () => {
          return closeModal();
        },
      },
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal.Content
        title={t('custom_employee_category.create_employee_category')}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal({ action: 'CLOSE' }),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.confirm'),
            type: 'submit',
            disabled: isLoading,
          },
        ]}
      >
        <Controller
          name="name"
          control={control}
          render={({ field: { name, value, onChange, ref } }) => {
            return (
              <TextField
                placeholder={t('custom_employee_category.category_name')}
                name={name}
                value={value}
                onChange={onChange}
                required
                fullWidth
                ref={ref}
              />
            );
          }}
        />
      </Modal.Content>
    </form>
  );
};
